import { Icon, IconProps } from "..";

export const Skateboard = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3673 4.6875V5.81164H14.243V6.93577H13.1187V8.05991H11.9944V9.18404H9.74578V10.3082H6.37289V11.4323H4.1243V12.5564H3V15.9401H4.1243V17.0642H5.24859V18.1884H6.37289V19.3125H8.63273V18.1884H9.75703V15.9401H10.8813V14.816H13.1299V13.6918H15.3785V12.5677H17.6159V13.6918H19.8757V12.5677H21V10.3082H19.8757V9.19528H21V5.81164H19.8757V4.6875H15.3673ZM18.7514 10.3194V11.4436H17.6271V12.5564H19.8645V10.3194H18.7514ZM6.38413 17.0642V18.1771H8.62149V17.0642H6.38413Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
